import React, { Component } from 'react'
import { Card ,Button,Accordion} from 'react-bootstrap';
import RequestManager from "../../singletons/RequestManager";
import BootstrapSwitchButton from 'bootstrap-switch-button-react'
import { BrowserRouter, Route, Switch  } from 'react-router-dom';
//import InventoryManagement from "./pages/InventoryManagement";
import LoadingOverlay from "react-loading-overlay";
import "./inventory.css"
import {  Container} from "reactstrap";



export default class InventoryCategory extends Component {

    constructor(props) {
        super(props);
        this.state = {
            storescategory: null,
            spinnerLoading: false,
            templateStoreId:null
        };
      }
    
        

      componentDidMount() {

       
        this.storecategories();
      }


    
     
      storecategories = async () => {
      
        this.setState({ spinnerLoading: true });
        let requestManager = new RequestManager();
    
        let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
        this.setState({templateStoreId : storeInformation.store.businessDomain.templateStoreId})
        // console.log(storeInformation.store.id,"storeidas")
    
        let params = {};
    
      
        params ={
          storeId: storeInformation.store.id
           //storeId: "U3RvcmU6NDcwOGNmYzQtNjhhOC00M2JhLWE3NWQtZWUxN2I1YjU3YTBl"
           }
       
        let response = await requestManager.getResponseFromPredefinedQuery(
          "storecategories",
          params
         
        );
    
        if (response.error === null) {
       
    
        this.setState({
          storescategory: response.data.store.categories.edges,
          spinnerLoading: false
         });
        // console.log(this.state.deliverydetail[0].node.id)
        console.log(response.data.store.categories.edges,"categories")
      }
      };
    
      handleinventorybutton = (event) => {
        //alert(event.target.id)
        let varCategoryId = event.target.id
        let varCategoryName = event.target.value
         if (this.state.templateStoreId != null){
         this.props.history.push(`/products/${varCategoryId}/${varCategoryName}`);
         }else{
         this.props.history.push(`/inventorymanagement/${varCategoryId}/${varCategoryName}`);
         }
         
    } 
  
    render() {
      let storeInformation = JSON.parse(localStorage.getItem("storeInformation"));
      const { spinnerLoading } = this.state;
      // let spin = this.props.match.params.spin;
      // this.setState({ spinnerLoading: spin });
      // this.setState({ spinnerLoading: true })

        return (
          <LoadingOverlay
          style={{ width: "100%", height: "100%", zIndex: 999 }}
          active={spinnerLoading === true ? true : false}
          spinner
          text="Loading ..."
        >
             <Container fluid style={{ padding: 0, margin: 0 }}>
                <h1>Categories</h1>
{this.state.storescategory && this.state.storescategory.map((categorydetails,index) => {
   return(
<Accordion  key={index} defaultActiveKey={index} className="mt-3">
  <Card>
    <Card.Header>
      <Accordion.Toggle as={Button} variant="link" eventKey={categorydetails.node.id}>
      {categorydetails.node.name}
     
      </Accordion.Toggle>

     {categorydetails.node.depth == 0 && (
       <button className="inventorybtn" id={categorydetails.node.id} variant="outline-success" value={categorydetails.node.name}  onClick={this.handleinventorybutton} >Inventory</button>   
      )
      }
    </Card.Header>
 {categorydetails.node && categorydetails.node.children.edges.map((childrencat, index) => {
   return(
    <Accordion.Collapse  key={index} eventKey={categorydetails.node.id}>
      <Card.Body >
<Accordion defaultActiveKey="0">
  <Card>
    <Card.Header>
      <Accordion.Toggle as={Button} variant="link" eventKey={categorydetails.node.id}>
      {childrencat.node.name}
      </Accordion.Toggle>
    
        {childrencat.node.depth == 0 && (
       <button className="inventorybtn" id={childrencat.node.id} variant="outline-success" value={childrencat.node.name} onClick={this.handleinventorybutton} >Inventory</button>   
      )}

    </Card.Header>

    {childrencat.node && childrencat.node.children.edges.map((subchildrencat, index) => {
   return(


<Accordion.Collapse eventKey={categorydetails.node.id} key={index}  >

      <Card.Body>{subchildrencat.node.name}
      {subchildrencat.node.depth == 0 && (
       <button className="inventorybtn" id={subchildrencat.node.id} value={subchildrencat.node.name} variant="outline-success" onClick={this.handleinventorybutton} >Inventory</button>   
      )}
      </Card.Body>
      

    </Accordion.Collapse>


)
})}
  </Card>
 
</Accordion>



      </Card.Body>
    </Accordion.Collapse>
   )
 })}
  </Card>

</Accordion>

)
})} 

</Container>
              </LoadingOverlay>
        )
    }
}





// WEBPACK FOOTER //
// ./src/pages/InventoryManagement/InventoryCategory.js